export default __webpack_public_path__ + "static/media/sample-multi-icon.a04e4612.svg";